define(
  'app/factories/tags_factory',['app/setup',
    'app/views/tags_view',
    'app/views/tag_page_list_view',
    'app/views/tags_list_view'
  ],
  function(takhfifan) {
    $('.tkh-tags-view').each(function(){
      return new takhfifan.tagsView({
        el: $(this)
      });
    });

    $('.tkh-tag-page-list-view').each(function () {
      return new takhfifan.tagPageListView({
        el: $(this),
        productCount: $(this).data("productCount"),
        pagesCount: $(this).data("pagesCount"),
        page: $(this).data("page")
      });
    });

    $('.tkh-tags-list-view').each(function () {
      return new takhfifan.tagsListView({
        el: $(this),
        tagsCount: $(this).data("tagsCount"),
        pagesCount: $(this).data("pagesCount"),
        page: $(this).data("page")
      });
    });
});
